<div class="card-header">
  {{ 'CONTACTS' | translate | uppercase}}
</div>
<div class="contacts-info-container">
  <div class="contacts-address-field all-fields">
    <div class="contacts-address-field-text all-texts">
      {{ 'ADDRESS' | translate | lowercase}}:
    </div>
    <div class="ccontacts-address-field-value all-values">
      гр. Варна, бул. "Мария Луиза" 4
    </div>
  </div>
  <div class="contacts-phone-field all-fields">
    <div class="contacts-phone-field-text all-texts">
      {{ 'PHONE' | translate | lowercase}}:
    </div>
    <div class="ccontacts-phone-field-value all-values">
      +359 52 612 918, +359 889 296 918
    </div>
  </div>
  <div class="contacts-email-field all-fields">
    <div class="contacts-email-field-text all-texts">
      {{ 'EMAIL' | translate | lowercase}}:
    </div>
    <div class="contacts-email-field-value all-values">
      office@logos.bg
    </div>
    <div class="contact-us-button" (click)="isContactFormShown=true">{{'CONTACT_US' | translate | lowercase}}
    </div>
  </div>
  <iframe class="contacts-google-maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1222.7502432298513!2d27.911197954981972!3d43.205156304452565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a453f517390e33%3A0x467f7add40da0e7e!2z0LHRg9C7LiDigJ7QmtC90Y_Qs9C40L3RjyDQnNCw0YDQuNGPINCb0YPQuNC30LDigJwgNCwgOTAwMCBWYXJuYSwgQnVsZ2FyaWE!5e0!3m2!1sen!2sie!4v1498467980314"></iframe>
</div>
<div class="contacts-overlay" *ngIf="isContactFormShown" (click)="isContactFormShown=false"></div>
<app-offer-contact-form [parent]="this" *ngIf="isContactFormShown"
                        [class.shown]="isContactFormShown"></app-offer-contact-form>
